import React,{useState,useEffect} from "react";

export default function AdminPages({
    page, nav, isA, isDB, user, lang, T, C, fmt, today, todayStr,
  monthStart, monthEnd, fyStart, fyEnd, last7, last30, filterByDate,
  getFYList, gCalc, dlCSV, numToWords,
  canAccess, getPlanLimit, tenantPlan, tenantInfo, pricing, offers,
  companies, setCompanies, custs, setCusts, supps, setSupps,
  prods, setProds, orders, setOrders, pays, setPays,
  purs, setPurs, notes, setNotes, users, setUsers,
  beats, setBeats, expenses, setExpenses, cheques, setCheques,
  modal, setModal, form, setForm,
  payOid, setPayOid, nItems, setNItems,
  payAmt, setPayAmt, payMethod2, setPayMethod2,
  payingCust, setPayingCust, dbOtp, setDbOtp,
  dbOtpOrderId, setDbOtpOrderId,
  dateFrom, setDateFrom, dateTo, setDateTo,
  gTab, setGTab, selFY, setSelFY, cf, setCf, prev, setPrev,
  aiInsight, aiLoading, aiPurSug, setAiPurSug,
  myCompany, setMyCompany, editMyComp, setEditMyComp,
  fOrders, fPays, fPurs, lowS, tSales, tPaid, tDue,
  loadData, showToast, handleOrder, handlePur, addPay, setSubPage, subPage,
  getAIInsights, getSmartPurchaseSuggestions,
  sendDailyReport, sendPaymentReminder, gc, API,
  accounts, setAccounts,
  srch, setSrch, oTab, setOTab, oPage, setOPage, payForm, setPayForm,
  pInv, pPur, pNote, pReceipt, waShare,
  Bdg, CB, Card, Sc, Row, Btn, Inp, Sel, Bar, Modal,
  AddProdToInvoice, InvModal, BankRecon, PhotoScanModal,
  NC, NI, SC, CC, editC, editComp, setEditComp,
  UnivFilter, CFbar
}){
  const [helplineData,setHelplineData]=useState(()=>{try{return JSON.parse(localStorage.getItem("sa_helpline")||"{}");}catch{return{};}});
  useEffect(()=>{
    (async()=>{try{const d=await API.get("/helpline");if(d&&d.phone){setHelplineData(d);localStorage.setItem("sa_helpline",JSON.stringify(d));}}catch(e){}})();
  },[]);

  return(<>

          {page==="usrs"&&isA&&<div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <div style={{fontSize:17,fontWeight:800}}>👤 Users & Staff</div>
              <Btn ch="+ Add Staff" oc={()=>{setModal("user");setForm({role:"staff"});}}/>
            </div>
            {users.map(u=><Card key={u.id} style={{marginBottom:8,borderLeft:`3px solid ${u.role==="admin"?C.primary:C.info}`}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <div style={{width:36,height:36,borderRadius:9,background:u.role==="admin"?C.primary+"20":u.role==="delivery"?C.warning+"20":C.info+"20",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>{u.role==="admin"?"👑":u.role==="delivery"?"🚚":"👤"}</div>
                  <div>
                    <div style={{fontWeight:700,fontSize:12}}>{u.name}</div>
                    <div style={{fontSize:9,color:C.sub}}>@{u.username} • {u.role}</div>
                  </div>
                </div>
                <Bdg l={u.active?"Active":"Inactive"} c={u.active?C.success:C.danger}/>
              </div>
              {u.role==="staff"&&<div style={{display:"flex",gap:10,background:C.bg,borderRadius:7,padding:"6px 10px",marginBottom:8}}>
                <div style={{textAlign:"center"}}><div style={{fontSize:12,fontWeight:700,color:C.primary}}>{orders.filter(o=>o.by===u.username).length}</div><div style={{fontSize:8,color:C.sub}}>Orders</div></div>
                <div style={{textAlign:"center"}}><div style={{fontSize:12,fontWeight:700,color:C.success}}>₹{fmt(pays.filter(p=>p.by===u.username).reduce((s,p)=>s+p.amt,0))}</div><div style={{fontSize:8,color:C.sub}}>Collected</div></div>
                <div style={{textAlign:"center"}}><div style={{fontSize:12,fontWeight:700,color:C.info}}>{custs.filter(c=>c.by===u.username).length}</div><div style={{fontSize:8,color:C.sub}}>Customers</div></div>
              </div>}
              {u.id!==user.id&&<div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                <Btn ch={u.active?"⏸ Deactivate":"▶ Activate"} oc={async()=>{setUsers(users.map(x=>x.id===u.id?{...x,active:!x.active}:x));try{await API.toggleUser(u.id);}catch(e){console.log(e);}await loadData(true);showToast(u.active?"Staff member deactivated!":"Staff member activated!");}} color={u.active?C.warning:C.success} out sm/>
                <Btn ch="✏️ Edit" oc={()=>{setModal("editUser");setForm({...u});}} color={C.primary} out sm/>
                <Btn ch="🔑 Password" oc={()=>{setModal("pwd");setForm({uid:u.id,uname:u.username});}} color={C.info} out sm/>
                <Btn ch="🗑️ Delete" oc={async()=>{if(window.confirm(`"${u.name}" will be permanently deleted. Are you sure?`)){setUsers(users.filter(x=>x.id!==u.id));try{await API.deleteUser(u.id);}catch(e){console.log(e);}await loadData(true);showToast("Staff member deleted!");}}} color={C.danger} out sm/>
              </div>}
            </Card>)}
          </div>}

          {/* ⚙️ SETTINGS PAGE — Admin only */}
          {/* ── SUBSCRIPTION PLANS PAGE ── */}
          {page==="plans"&&<div>
            <div style={{fontSize:17,fontWeight:800,marginBottom:4}}>💎 Subscription Plans</div>
            <div style={{fontSize:12,color:C.sub,marginBottom:16}}>Choose or upgrade your plan</div>

            {/* Current Plan */}
            {(()=>{
              const ti=tenantInfo||{plan:"trial",status:"active"};
              const dl=ti.trial_end?Math.ceil((new Date(ti.trial_end)-new Date())/864e5):null;
              const isTrial=ti.plan==="trial";
              const isExpired=ti.status==="expired"||(dl!==null&&dl<0);
              const planMeta={trial:{icon:"🆓",name:"Free Trial"},starter:{icon:"⭐",name:"Starter"},basic:{icon:"🚀",name:"Basic"},pro:{icon:"💎",name:"Pro"},enterprise:{icon:"🏢",name:"Enterprise"}};
              const pm=planMeta[ti.plan]||planMeta.trial;
              return <div style={{background:isExpired?"linear-gradient(135deg,#7F1D1D,#991B1B)":"linear-gradient(135deg,#1C2B3A,#2D4A63)",borderRadius:14,padding:16,marginBottom:16,color:"#fff"}}>
                <div style={{fontSize:12,color:"#94A3B8",marginBottom:4}}>Current Plan</div>
                <div style={{fontSize:20,fontWeight:800}}>{pm.icon} {pm.name}{!isTrial&&" Plan"}</div>
                <div style={{fontSize:12,color:isExpired?"#FCA5A5":"#94A3B8",marginTop:4}}>
                  {isExpired?"⚠️ Expired — please subscribe to continue":
                   dl!==null?(isTrial?`${dl>0?dl:0} days remaining`:`Valid until ${new Date(ti.trial_end).toLocaleDateString("en-IN")}`):
                   "Active"}
                </div>
              </div>;
            })()}

            {/* Active Offers */}
            {(()=>{
              const today=todayStr();
              const active=(offers||[]).filter(o=>(!o.from||o.from<=today)&&(!o.till||o.till>=today));
              if(!active.length) return null;
              return active.map(o=><div key={o.id} style={{background:"linear-gradient(135deg,#D97706,#F59E0B)",borderRadius:12,padding:14,marginBottom:12,color:"#fff"}}>
                <div style={{fontWeight:800,fontSize:14}}>🎁 {o.name}</div>
                <div style={{fontSize:13,marginTop:2}}>
                  {o.type==="percent"?`${o.discount}% off`:o.type==="fixed"?`₹${o.discount} off`:`+${o.discount} bonus days`} on your subscription!
                </div>
                {o.code&&<div style={{fontSize:12,marginTop:6,background:"rgba(255,255,255,0.2)",display:"inline-block",padding:"3px 10px",borderRadius:7,fontWeight:700}}>Use code: {o.code}</div>}
                {o.till&&<div style={{fontSize:10,marginTop:6,opacity:0.9}}>Valid till {new Date(o.till).toLocaleDateString("en-IN")}</div>}
              </div>);
            })()}

            {/* Plans */}
            {[
              {key:"starter",name:"Starter",price:pricing?.starter?.price||299,color:"#64748B",icon:"⭐",users:"1 Admin + 2 Staff",features:["Unlimited Orders","GST Invoice","WhatsApp Share","Basic Reports","Email Support"]},
              {key:"basic",name:"Basic",price:pricing?.basic?.price||499,color:C.primary,icon:"🚀",users:"1 Admin + 5 Staff",popular:true,features:["All Starter features","AI Bill Scanner","Beat Management","Expense Tracking","Delivery Boy","Priority Support"]},
              {key:"pro",name:"Pro",price:pricing?.pro?.price||999,color:C.purple,icon:"💎",users:"3 Admin + 8 Staff",features:["All Basic features","AI Business Insights","Smart Order Suggest","Customer Loyalty","Cheque Management","Dedicated Support"]},
              {key:"enterprise",name:"Enterprise",price:pricing?.enterprise?.price||1999,color:"#B45309",icon:"🏢",users:"Unlimited Users",features:["All Pro features","Custom Domain","White Label","API Access","SLA Guarantee","24/7 Support"]},
            ].map(plan=>(
              <div key={plan.name} style={{background:"#fff",borderRadius:14,padding:16,marginBottom:12,border:`2px solid ${tenantInfo?.plan===plan.key?C.success:plan.popular?plan.color:C.border}`,position:"relative"}}>
                {tenantInfo?.plan===plan.key
                  ?<div style={{position:"absolute",top:-10,left:"50%",transform:"translateX(-50%)",background:C.success,color:"#fff",fontSize:10,fontWeight:700,padding:"2px 12px",borderRadius:20}}>✓ CURRENT PLAN</div>
                  :plan.popular&&<div style={{position:"absolute",top:-10,left:"50%",transform:"translateX(-50%)",background:plan.color,color:"#fff",fontSize:10,fontWeight:700,padding:"2px 12px",borderRadius:20}}>⭐ MOST POPULAR</div>}
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                  <div>
                    <div style={{fontSize:16,fontWeight:800,color:plan.color}}>{plan.icon} {plan.name}</div>
                    <div style={{fontSize:11,color:C.sub}}>{plan.users}</div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{fontSize:22,fontWeight:800,color:plan.color}}>₹{plan.price}<span style={{fontSize:12,color:C.sub}}>/mo</span></div>
                    <div style={{fontSize:10,color:C.success}}>₹{Math.round(plan.price*12*0.70).toLocaleString("en-IN")}/year (30% off)</div>
                  </div>
                </div>
                {plan.features.map(f=>(
                  <div key={f} style={{display:"flex",alignItems:"center",gap:6,fontSize:12,padding:"3px 0"}}>
                    <span style={{color:C.success,fontSize:14}}>✅</span>{f}
                  </div>
                ))}
                {tenantInfo?.plan!==plan.key&&<button onClick={()=>{
                  const ph=(helplineData.whatsapp||helplineData.phone||"").replace(/\D/g,"");
                  const msg=encodeURIComponent(`Hello!\n\nI would like to subscribe to the DawnToDusk Pro ${plan.name} Plan (₹${plan.price}/month).\n\nMy name: ${user?.name||""}\nPhone: \n\nPlease contact me. Thank you!`);
                  if(ph) window.open(`https://wa.me/91${ph}?text=${msg}`,"_blank");
                  else showToast("Helpline number is not set — please contact the administrator","err");
                }} style={{width:"100%",marginTop:12,padding:"10px",background:plan.color,border:"none",color:"#fff",borderRadius:10,cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit"}}>
                  📱 Subscribe via WhatsApp
                </button>}
              </div>
            ))}

            {/* Contact */}
            <div style={{background:"#F0FDF4",borderRadius:12,padding:14,textAlign:"center",border:"1px solid #BBF7D0"}}>
              <div style={{fontWeight:700,fontSize:13,marginBottom:6}}>🤔 Have a question?</div>
              <div style={{fontSize:12,color:C.sub,marginBottom:8}}>Talk to our team</div>
              {(()=>{
                const hl=helplineData;
                return hl.phone?<>
                  <a href={`tel:${hl.phone}`} style={{display:"block",fontSize:14,fontWeight:800,color:C.success,textDecoration:"none",marginBottom:4}}>📞 {hl.phone}</a>
                  {hl.whatsapp&&<a href={`https://wa.me/91${hl.whatsapp.replace(/\D/g,"")}`} target="_blank" rel="noreferrer" style={{display:"block",fontSize:12,color:"#25D366",fontWeight:600,textDecoration:"none"}}>💬 WhatsApp</a>}
                  <div style={{fontSize:10,color:C.sub,marginTop:4}}>{hl.hours||"Mon-Sat 10AM-6PM"}</div>
                </>:<div style={{fontSize:12,color:C.sub}}>Please contact your administrator</div>;
              })()}
            </div>
          </div>}

          {page==="settings"&&isA&&<div>
            <div style={{fontSize:17,fontWeight:800,marginBottom:6}}>⚙️ Settings</div>

            {/* MY COMPANY PROFILE */}
            <Card style={{marginBottom:14,borderLeft:`4px solid ${C.primary}`}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                <div style={{display:"flex",alignItems:"center",gap:9}}>
                  <div style={{width:42,height:42,borderRadius:10,background:C.primary,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20}}>🏢</div>
                  <div>
                    <div style={{fontWeight:800,fontSize:14,color:C.primary}}>{myCompany.name||"My Company"}</div>
                    <div style={{fontSize:10,color:C.sub}}>Your own distribution firm</div>
                  </div>
                </div>
                {editMyComp
                  ?<div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                    <Btn ch="💾 Save" oc={async()=>{
                      setEditMyComp(false);
                      localStorage.setItem("gd_myco",JSON.stringify(myCompany));
                      try{
                        const saved = await API.post("/my-company",myCompany);
                        if(saved && saved.id){
                          setMyCompany(prev=>({...prev,...saved}));
                          localStorage.setItem("gd_myco",JSON.stringify(saved));
                        }
                        showToast("✅ Company profile saved!");
                      }catch(e){
                        showToast("⚠️ "+e.message,"err");
                      }
                    }} color={C.success} sm/>
                    <Btn ch="✕" oc={()=>setEditMyComp(false)} color={C.sub} out sm/>
                  </div>
                  :<Btn ch="✏️ Edit" oc={()=>setEditMyComp(true)} color={C.primary} out sm/>
                }
              </div>

              {editMyComp?(
                <div>
                  {/* Logo + QR Upload */}
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
                    <div style={{background:"#F8FAFC",borderRadius:10,padding:"10px",textAlign:"center"}}>
                      <div style={{fontSize:11,fontWeight:600,color:C.sub,marginBottom:6}}>🖼️ Logo Upload</div>
                      {myCompany.logo
                        ?<img src={myCompany.logo} alt="logo" style={{maxHeight:60,maxWidth:"100%",borderRadius:6,marginBottom:6}}/>
                        :<div style={{width:60,height:60,borderRadius:8,background:C.border,display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,margin:"0 auto 6px"}}>🏢</div>
                      }
                      <label style={{cursor:"pointer",fontSize:11,color:C.primary,fontWeight:600}}>
                        📁 Choose Logo
                        <input type="file" accept="image/*" onChange={e=>{const f=e.target.files[0];if(f){const r=new FileReader();r.onload=ev=>setMyCompany({...myCompany,logo:ev.target.result});r.readAsDataURL(f);}}} style={{display:"none"}}/>
                      </label>
                      {myCompany.logo&&<button onClick={()=>setMyCompany({...myCompany,logo:""})} style={{display:"block",margin:"4px auto 0",fontSize:10,color:C.danger,background:"none",border:"none",cursor:"pointer"}}>✕ Remove</button>}
                    </div>
                    <div style={{background:"#F8FAFC",borderRadius:10,padding:"10px",textAlign:"center"}}>
                      <div style={{fontSize:11,fontWeight:600,color:C.sub,marginBottom:6}}>📱 QR Code Upload</div>
                      {myCompany.qr
                        ?<img src={myCompany.qr} alt="qr" style={{maxHeight:60,maxWidth:"100%",borderRadius:6,marginBottom:6}}/>
                        :<div style={{width:60,height:60,borderRadius:8,background:C.border,display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,margin:"0 auto 6px"}}>📱</div>
                      }
                      <label style={{cursor:"pointer",fontSize:11,color:C.primary,fontWeight:600}}>
                        📁 Choose QR Code
                        <input type="file" accept="image/*" onChange={e=>{const f=e.target.files[0];if(f){const r=new FileReader();r.onload=ev=>setMyCompany({...myCompany,qr:ev.target.result});r.readAsDataURL(f);}}} style={{display:"none"}}/>
                      </label>
                      {myCompany.qr&&<button onClick={()=>setMyCompany({...myCompany,qr:""})} style={{display:"block",margin:"4px auto 0",fontSize:10,color:C.danger,background:"none",border:"none",cursor:"pointer"}}>✕ Remove</button>}
                    </div>
                  </div>

                  {/* Business Info */}
                  <div style={{background:"#F8FAFC",borderRadius:10,padding:"12px",marginBottom:10}}>
                    <div style={{fontSize:12,fontWeight:700,color:C.sub,marginBottom:8}}>🏢 Business Info</div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                      <Inp l="Firm Name" v={myCompany.name||""} oc={e=>setMyCompany({...myCompany,name:e.target.value})} p="Dawn To Dusk Distributors"/>
                      <Inp l="Owner Name" v={myCompany.owner||""} oc={e=>setMyCompany({...myCompany,owner:e.target.value})} p="Your name"/>
                      <Inp l="GSTIN" v={myCompany.gstin||""} oc={e=>setMyCompany({...myCompany,gstin:e.target.value})} p="27AABCD1234R1Z5"/>
                      <Inp l="Phone / WhatsApp" v={myCompany.phone||""} oc={e=>setMyCompany({...myCompany,phone:e.target.value})} p="9876543210"/>
                      <Inp l="Email" v={myCompany.email||""} oc={e=>setMyCompany({...myCompany,email:e.target.value})} p="email@example.com"/>
                      <Inp l="Website (optional)" v={myCompany.website||""} oc={e=>setMyCompany({...myCompany,website:e.target.value})} p="www.example.com"/>
                    </div>
                    <div style={{marginBottom:10}}>
                      <div style={{fontSize:11,fontWeight:600,color:C.sub,marginBottom:4}}>📍 Full Address</div>
                      <textarea value={myCompany.address||""} onChange={e=>setMyCompany({...myCompany,address:e.target.value})} placeholder="Street, Area, City, State - Pincode" rows={2} style={{width:"100%",padding:"8px 11px",borderRadius:8,border:`1.5px solid ${C.border}`,fontSize:12,outline:"none",boxSizing:"border-box",fontFamily:"inherit",resize:"vertical"}}/>
                    </div>
                    <Inp l="MSME / Udyam Number (optional)" v={myCompany.msme||""} oc={e=>setMyCompany({...myCompany,msme:e.target.value})} p="UDYAM-XX-00-0000000"/>
                  </div>

                  {/* Bank Details */}
                  <div style={{background:"#F8FAFC",borderRadius:10,padding:"12px",marginBottom:10}}>
                    <div style={{fontSize:12,fontWeight:700,color:C.sub,marginBottom:8}}>🏦 Bank & Payment</div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                      <Inp l="Bank Name" v={myCompany.bank||""} oc={e=>setMyCompany({...myCompany,bank:e.target.value})} p="HDFC Bank"/>
                      <Inp l="Account Number" v={myCompany.acc||""} oc={e=>setMyCompany({...myCompany,acc:e.target.value})} p="XXXXXXXXXXXX"/>
                      <Inp l="IFSC Code" v={myCompany.ifsc||""} oc={e=>setMyCompany({...myCompany,ifsc:e.target.value})} p="HDFC0001234"/>
                      <Inp l="UPI ID" v={myCompany.upi||""} oc={e=>setMyCompany({...myCompany,upi:e.target.value})} p="yourname@hdfc"/>
                    </div>
                  </div>

                  {/* Invoice Settings */}
                  <div style={{background:"#F8FAFC",borderRadius:10,padding:"12px",marginBottom:10}}>
                    <div style={{fontSize:12,fontWeight:700,color:C.sub,marginBottom:8}}>🧾 Invoice Settings</div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                      <Inp l="Terms & Conditions Line 1" v={myCompany.terms1||""} oc={e=>setMyCompany({...myCompany,terms1:e.target.value})} p="Goods once sold will not be taken back"/>
                      <Inp l="Terms & Conditions Line 2" v={myCompany.terms2||""} oc={e=>setMyCompany({...myCompany,terms2:e.target.value})} p="Bills not paid due date attract 24% interest"/>
                      <Inp l="Terms & Conditions Line 3" v={myCompany.terms3||""} oc={e=>setMyCompany({...myCompany,terms3:e.target.value})} p="Subject to local jurisdiction"/>
                      <Inp l="Payment Due Days" v={myCompany.dueDays||""} oc={e=>setMyCompany({...myCompany,dueDays:e.target.value})} p="30"/>
                    </div>
                  </div>

                  <Btn ch="💾 Save Company Profile" oc={async()=>{
                    setEditMyComp(false);
                    localStorage.setItem("gd_myco",JSON.stringify(myCompany));
                    try{
                      const saved = await API.post("/my-company",myCompany);
                      if(saved && saved.id){
                        setMyCompany(prev=>({...prev,...saved}));
                        localStorage.setItem("gd_myco",JSON.stringify(saved));
                      }
                      showToast("✅ Company profile saved!");
                    }catch(e){
                      showToast("⚠️ "+e.message,"err");
                    }
                  }} color={C.success} s={{width:"100%",justifyContent:"center"}}/>
                </div>
              ):(
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,fontSize:11}}>
                  <div style={{display:"flex",flexDirection:"column",gap:4}}>
                    {myCompany.logo&&<img src={myCompany.logo} alt="logo" style={{maxHeight:40,maxWidth:120,borderRadius:5,marginBottom:4}}/>}
                    <div><b>Firm:</b> {myCompany.name||"—"}</div>
                    <div><b>Owner:</b> {myCompany.owner||"—"}</div>
                    <div><b>GSTIN:</b> {myCompany.gstin||"—"}</div>
                    <div><b>Phone:</b> {myCompany.phone||"—"}</div>
                    <div><b>Address:</b> {myCompany.address||"—"}</div>
                  </div>
                  <div style={{display:"flex",flexDirection:"column",gap:4}}>
                    {myCompany.qr&&<img src={myCompany.qr} alt="qr" style={{maxHeight:60,maxWidth:60,borderRadius:5,marginBottom:4}}/>}
                    <div><b>Bank:</b> {myCompany.bank||"—"}</div>
                    <div><b>A/c:</b> {myCompany.acc||"—"}</div>
                    <div><b>IFSC:</b> {myCompany.ifsc||"—"}</div>
                    <div><b>UPI:</b> {myCompany.upi||"—"}</div>
                    <div><b>MSME:</b> {myCompany.msme||"—"}</div>
                  </div>
                </div>
              )}
            </Card>

            {/* INVOICE PRINT SETTINGS */}
            <Card style={{marginBottom:14,borderLeft:`4px solid ${C.warning}`}}>
              <div style={{fontWeight:800,fontSize:14,color:C.warning,marginBottom:12}}>🖨️ Invoice Print Settings</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                {/* Paper Size */}
                <div>
                  <div style={{fontSize:11,fontWeight:600,color:C.sub,marginBottom:6}}>📄 Paper Size</div>
                  {["A4 (Full Page)","A5 (Half Page)","A6 (Quarter)","Thermal (3 inch)"].map(s=>(
                    <label key={s} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 0",cursor:"pointer"}}>
                      <input type="radio" name="paperSize" value={s}
                        checked={(myCompany.paperSize||"A4 (Full Page)")===s}
                        onChange={async e=>{const v={...myCompany,paperSize:e.target.value};setMyCompany(v);localStorage.setItem("gd_myco",JSON.stringify(v));try{await API.post("/my-company",v);}catch(ex){showToast("⚠️ "+ex.message,"err");}}}
                        style={{width:14,height:14}}/>
                      <span style={{fontSize:12}}>{s}</span>
                    </label>
                  ))}
                </div>
                {/* Print Copies */}
                <div>
                  <div style={{fontSize:11,fontWeight:600,color:C.sub,marginBottom:6}}>📋 Print Copies</div>
                  {["1 Copy","2 Copies (Original + Duplicate)","3 Copies (Orig+Dup+Triplicate)"].map(s=>(
                    <label key={s} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 0",cursor:"pointer"}}>
                      <input type="radio" name="copies" value={s}
                        checked={(myCompany.printCopies||"1 Copy")===s}
                        onChange={async e=>{const v={...myCompany,printCopies:e.target.value};setMyCompany(v);localStorage.setItem("gd_myco",JSON.stringify(v));try{await API.post("/my-company",v);}catch(ex){showToast("⚠️ "+ex.message,"err");}}}
                        style={{width:14,height:14}}/>
                      <span style={{fontSize:12}}>{s}</span>
                    </label>
                  ))}
                </div>
              </div>
              {/* Discount On Invoice */}
              <div style={{marginTop:12,padding:"10px 12px",background:"#FFFBEB",borderRadius:9,border:`1px solid ${C.warning}40`}}>
                <div style={{fontSize:12,fontWeight:700,color:C.warning,marginBottom:8}}>💯 Show Discount on Invoice?</div>
                <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                  {[
                    {k:"showDiscount",l:"Item wise Discount"},
                    {k:"showOverallDisc",l:"Overall Discount"},
                    {k:"showMRP",l:"MRP Column"},
                    {k:"showHSN",l:"HSN Code"},
                    {k:"showFreeQty",l:"Free Qty"},
                  ].map(opt=>(
                    <label key={opt.k} style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",background:"#fff",padding:"5px 10px",borderRadius:7,border:`1px solid ${C.border}`}}>
                      <input type="checkbox"
                        checked={myCompany[opt.k]!==false}
                        onChange={async e=>{const v={...myCompany,[opt.k]:e.target.checked};setMyCompany(v);localStorage.setItem("gd_myco",JSON.stringify(v));try{await API.post("/my-company",v);}catch(ex){showToast("⚠️ "+ex.message,"err");}}}
                        style={{width:14,height:14}}/>
                      <span style={{fontSize:11,fontWeight:600}}>{opt.l}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div style={{marginTop:8,fontSize:10,color:C.sub}}>
                Current: {myCompany.paperSize||"A4"} • {myCompany.printCopies||"1 Copy"} • Discount: {myCompany.showDiscount!==false?"ON":"OFF"} • Free Qty: {myCompany.showFreeQty!==false?"ON":"OFF"}
              </div>
            </Card>

            {/* DISTRIBUTION COMPANIES */}
            {/* App settings */}
            <Card style={{marginBottom:14}}>
              <div style={{fontSize:13,fontWeight:700,marginBottom:10}}>👤 Password Change</div>
              {users.map(u=>(
                <div key={u.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 0",borderBottom:`1px solid ${C.border}`}}>
                  <div><div style={{fontSize:12,fontWeight:600}}>{u.name}</div><div style={{fontSize:10,color:C.sub}}>@{u.username} • {u.role}</div></div>
                  <Btn ch="🔑 Change" oc={()=>{setModal("pwd");setForm({uid:u.id,uname:u.name});}} color={C.primary} out sm/>
                </div>
              ))}
            </Card>
          </div>}

      {/* ── All Modals ─────────────────────────────────────────────── */}

      {/* Note Modal */}
  </>);
}
